import { apiCall, ApiConfig } from '../../config/api'
import { ConfigurationSaga } from '../../interfaces/Configuration/Configuration'
import { getConfigurationAction } from '../actions/configurationActions'
import { retry, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse } from 'axios'
import { GET_CONFIGURATION } from '../types/configurationsActionsTypes'

const RETRY_COUNT = 3 // Número de intentos
const RETRY_DELAY = 1000 // Tiempo de espera entre intentos en milisegundos

export function* getConfigurationAsync() {
  try {
    const { status, data }: AxiosResponse<ConfigurationSaga[]> = yield retry(
      RETRY_COUNT,
      RETRY_DELAY,
      apiCall,
      'GET',
      `${ApiConfig.ConfigurationApi}/Get`
    )
    if (status === 200) {
      yield put(getConfigurationAction(data))
    }
  } catch (error) {
    yield put(getConfigurationAction([], ''))
  }
}

export function* watchGetConfigurationAsync() {
  yield takeEvery(GET_CONFIGURATION, getConfigurationAsync)
}